export default {
  title: {
    id: 'reassurance_service_warranty',
    defaultMessage: '{warrantyDuration}-year minimum warranty',
  },
}
